import React from 'react'
import styles from './writing-overflow.css'

export default function WritingOverflow (props) {
  let { onClose, errorType} = props
  let errorText = '需要保证字数符合要求哦';
  let errorAction = '提交之前';
  let errorBtn = '重新编辑';
  if (errorType === 'overFlow'){
    errorType = '字数超限无法提交';
    errorText = '需要保证字数符合需求哦';
  }else if (errorType === 'empty'){
    errorType = '字数为空';
    errorText = '需要先完成作文哦';
  }else if (errorType === 'aduioEmpty'){
    errorType = '您还没有录音'
    errorText = '需要完成录音才可以哦'
  }else if (errorType === 'BrowserNotFit'){
    errorType = '浏览器暂不支持';
    errorAction = '非常抱歉';
    errorText = '口语练习目前仅能在Chrome浏览器中使用哦';
    errorBtn = '确定';
  }
  return (
    <div className={ styles.root }>
      <div className={ styles.box }>
        <i className="icon-close" onClick={ onClose }></i>
        <div className={ styles.text }>
          <div className={ styles.t1 }>{errorType}</div>
          <div className={ styles.t2 }>{errorAction}<br />{errorText}</div>
          <div className={ styles.t3 } onClick={ onClose }>{errorBtn}</div>
        </div>
      </div>
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/pages/Practice/WritingOverflow.js
 **/